export default "__VITE_ASSET__CAaCzjdD__"